// Models
import Model from './Model'

class CurrencyRate extends Model {
  get schema () {
    return [
      'rates',
      'ratesDate',
      'updatedAt'
    ]
  }
}

export default CurrencyRate
